"use client";
import React from "react";
import Image from "next/image";
import {
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IMAGES, WEB_COLORS, CurrencyConverter } from "@/lib/constants";
import { useTranslations } from "next-intl";
import { Check } from "@mui/icons-material";
import { DividerComponent } from "@/components";
import { usePathname } from "next/navigation";
import styles from "../checkeligibility.module.css";
const CheckEligibilityLeftCard = ({ utmCampaign }) => {
  const t = useTranslations("CheckEligibility");
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("sm"));
  const path = usePathname();
  return (
    <Stack
      height={"100%"}
      p={{ xs: 3, sm: 6 }}
      gap={1}
      justifyContent={"flex-start"}
    >
      <Stack spacing={2}>
        <Stack>
          <Typography
            variant="h4"
            fontWeight={"bold"}
            color={"#FFFFFF"}
            fontSize={{ md: 32, xs: 28 }}
          >
            {t("checkeligibilitytext")}
          </Typography>

          <Typography
            variant="h6"
            align="left"
            fontWeight={300}
            fontSize={{ xs: 12, sm: 16 }}
            color={"#FFFFFF"}
          >
            {t("checkeligibilitysubtext")}
          </Typography>
        </Stack>
      </Stack>
      <Stack gap={{ xs: 0.5 }}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} sx={{ pt: 3 }}>
            <Stack gap={{ xs: 0.5, sm: 2 }}>
              <Stack
                className={styles["gradient-border-box"]}
                direction={"row"}
                spacing={1}
                p={1}
                borderRadius={1}
                alignItems={"center"}
              >
                <Image
                  src={IMAGES.preApprovedIcon}
                  alt="Banner"
                  height={isBelowMd ? 20 : 32}
                  width={isBelowMd ? 20 : 32}
                />
                <Typography fontSize={{ xs: 10, sm: 14 }} color={"#fff"}>
                  {t("takelessmin")}
                </Typography>
              </Stack>
              <Stack
                className={styles["gradient-border-box"]}
                direction={"row"}
                spacing={1}
                p={1}
                borderRadius={1}
                alignItems={"center"}
              >
                <Image
                  src={IMAGES.personalizedIcon}
                  alt="Banner"
                  height={isBelowMd ? 20 : 32}
                  width={isBelowMd ? 20 : 32}
                />
                <Typography fontSize={{ xs: 10, sm: 14 }} color={"#fff"}>
                  {t("noimpect")}
                </Typography>
              </Stack>
              <Stack
                className={styles["gradient-border-box"]}
                direction={"row"}
                spacing={1}
                p={1}
                borderRadius={1}
                alignItems={"center"}
              >
                <Image
                  src={IMAGES.abolutalyFreeIcon}
                  alt="Banner"
                  height={isBelowMd ? 20 : 32}
                  width={isBelowMd ? 20 : 32}
                />
                <Typography fontSize={{ xs: 10, sm: 14 }} color={"#fff"}>
                  {t("secure&confidential")}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
        {path?.includes("personal") && (
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              sx={{
                position: "relative",
                height: "fit-content",
                height: isBelowMd ? 111 : 200,
              }}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"flex-end"}
                position={"absolute"}
                right={isBelowMd ? -50 : -74}
              >
                <Image
                  src={IMAGES.loanhand}
                  alt="Banner"
                  height={isBelowMd ? 111 : 200}
                  width={isBelowMd ? 150 : 320}
                />
              </Stack>
            </Grid>
          </Grid>
        )}
      </Stack>
    </Stack>
  );
};

export default CheckEligibilityLeftCard;
